import { PropsWithChildren } from 'react'
import { WagmiProvider } from 'wagmi'
import { TENANT_CONFIG } from '@config'
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'

const projectId = TENANT_CONFIG.projectId

const metadata = {
  name: TENANT_CONFIG.name,
  description: TENANT_CONFIG.meta.description,
  url: origin, // origin must match your domain & subdomain
  icons: ['/images/favicon.ico']
}

const chains = TENANT_CONFIG.supportedChains
const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableCoinbase: true,
  auth: {
    email: false // default to true
  }
})

// Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  chainImages: {
    5000: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZWGOcJRjxOB8qFUJE1LvTxAxUJbMptiqIr0KKM9CBNyt0xwOSnv8v_YRSZJ-ffy10f1k&usqp=CAU'
  },
  featuredWalletIds: TENANT_CONFIG.wallets,
  allWallets: 'ONLY_MOBILE',
  excludeWalletIds: ['1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369'],
  enableAnalytics: true // Optional - defaults to your Cloud configuration,
})

const WagmiWrapper = ({ children }: PropsWithChildren) => {
  return <WagmiProvider config={config}>{children}</WagmiProvider>
}
export default WagmiWrapper
